module.exports = __webpack_public_path__ + "static/assets/2c0e5ccf73c7e2ce7f1801c443959dc9.png";